// src/services/session.js
// Sesión local (JWT del backend). Lee el perfil con GET /auth/me.
import { apiGet } from './api';

export const fetchMe = () => apiGet('/auth/me');

export function getStoredRole() {
  try { return (localStorage.getItem('role') || '').toLowerCase(); } catch { return ''; }
}
